'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg16 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 16, height: 17, viewBox: "0 0 16 17", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.4756 2.34685C11.1156 1.92807 10.4842 1.88047 10.0654 2.24053L3.94601 7.50195C3.935 7.51142 3.92385 7.52099 3.91258 7.53066C3.73776 7.6808 3.5354 7.85457 3.38506 8.02592C3.20644 8.22948 2.98298 8.5584 2.98298 9.01846C2.98298 9.47853 3.20644 9.80744 3.38505 10.011C3.53539 10.1824 3.73775 10.3561 3.91257 10.5063C3.92384 10.5159 3.93498 10.5255 3.946 10.535L10.01 15.7488C10.4287 16.1089 11.0601 16.0613 11.4202 15.6425C11.7802 15.2238 11.7327 14.5924 11.3139 14.2323L5.24991 9.01847L11.3693 3.75706C11.7881 3.397 11.8357 2.76563 11.4756 2.34685Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg16;
//# sourceMappingURL=16.js.map
